<template>
<div class="chapter">
<div class="inner_page">
<a id="pxvii"></a>
<a id="pxviii"></a>
<a id="p1"></a>
<h1 class="chaptertitle ">Home</h1>
<p class="left ">Y<span class="smallcaps">AAK IS THE</span> K<span class="smallcaps">OOTENAI WORD</span> for arrow and it is the name of the valley where I live. The Kootenai once hunted in the upper part of the valley, the place where my cabin is now.</p>
<p class="follow">Those of us who live here now hunt through the ice for fish in January, hunt deer and elk in the snows of November, grouse in the blazing autumn; we gather berries in August, and tend to our gardens in the brief summer. We hunt firewood; we hunt mushrooms. We hunt for the deer’s dropped antlers; we hunt for fir boughs for Christmas wreaths; we hunt a duck or two; and we hunt flat rocks for our rock walls. We hunt daisies and asters and lupine and paintbrush for our children in June. We hunt horses that have slipped through buck-and-rail fences knocked askew like toothpicks by night-passing moose.</p>
<p class="follow">Three couples up here trap and tan hides. There are three preachers; two bars. A handful of hunting and fishing guides. We do seasonal work, rhythmic work—planting trees in the spring to try to regenerate the scabrous clearcuts; we saw roadside lodgepole blowdown for firewood, and hundred-inch studs, to cart to Libby or Bonners Ferry in the backs of our beat-up pickups.</p>
<p class="follow">The people who live here—who stay here—have fallen in love with the shape of this land. Its cycle of days.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01.vue?e009c03c